import { render, staticRenderFns } from "./protocolList.vue?vue&type=template&id=7ddc9295&scoped=true"
import script from "./protocolList.vue?vue&type=script&lang=js"
export * from "./protocolList.vue?vue&type=script&lang=js"
import style0 from "./protocolList.vue?vue&type=style&index=0&id=7ddc9295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc9295",
  null
  
)

export default component.exports